import { api } from "roboflex-thalamus-request-handler";

function comBarraFinal(url) {
  if (!url) return "";
  return url.endsWith("/") ? url : `${url}/`;
}

function envVar(name) {
  // Acesso dinâmico evita bake parcial; no bundle do host o DefinePlugin ainda resolve.
  try {
    return (typeof process !== "undefined" && process.env && process.env[name]) || "";
  } catch {
    return "";
  }
}

/**
 * Base da API do app consumidor (mesma instância do request-handler).
 */
export function apiBaseUrl() {
  const fromApi = api?.defaults?.baseURL || "";
  if (fromApi) return comBarraFinal(fromApi);
  return comBarraFinal(envVar("VUE_APP_ROOT_API"));
}

export function storageBaseUrl() {
  const fromEnv = envVar("VUE_APP_ROOT_STORAGE");
  if (fromEnv) return comBarraFinal(fromEnv);

  const apiUrl = apiBaseUrl();
  if (apiUrl) {
    return comBarraFinal(apiUrl.replace(/\/api\/?$/i, "/storage"));
  }

  return "https://api.thalamus.ind.br/storage/";
}

export function portalBaseUrl(buildMode) {
  const fromEnv = envVar("VUE_APP_PORTAL_URL");
  if (fromEnv) return comBarraFinal(fromEnv);

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return `${window.location.origin}/#/`;
    }
  }

  const ssoLogin = envVar("VUE_APP_ROOT_SSO_LOGIN");
  if (ssoLogin.includes("#/")) {
    return ssoLogin.replace(/#\/.*$/, "#/");
  }

  if (buildMode === "staging" || buildMode === "development") {
    return "https://portal-homologacao.thalamus.ind.br/#/";
  }

  return "https://portal.thalamus.ind.br/#/";
}

export function dadosCadastraisUrl(buildMode) {
  const fromEnv = envVar("VUE_APP_DADOS_CADASTRAIS_URL");
  if (fromEnv) return fromEnv;

  if (buildMode === "staging" || buildMode === "development") {
    return "https://dados-basicos-homologacao.thalamus.ind.br/#/profile";
  }

  return "https://dados-basicos.thalamus.ind.br/#/profile";
}

/** @deprecated Use apiBaseUrl() / paths relativos no request-handler */
export const devApiUrl = "";
/** @deprecated Use apiBaseUrl() / paths relativos no request-handler */
export const prodApiUrl = "";
